import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import {Controller} from 'react-hook-form';

import CustomCheckbox from '../../../../../form/Checkbox/Checkbox';

const PartialUpdateTableList = ({tables, control}) => (
  <Box mx={2} mb={2} sx={{borderRadius: 2, border: '1px solid lightgrey'}}>
    {tables.map((table, index) => (
      <Box
        key={table}
        px={2}
        sx={{
          borderBottom: index !== tables.length - 1 ? '1px solid lightgrey' : 'none'
        }}
      >
        <Controller name={table} control={control} render={({field}) => <CustomCheckbox label={table} checked={field.value} onChange={(_, checked) => field.onChange(checked)} size="small" />} />
      </Box>
    ))}
  </Box>
);

PartialUpdateTableList.propTypes = {
  tables: PropTypes.arrayOf(PropTypes.string).isRequired,
  control: PropTypes.object.isRequired
};

export default PartialUpdateTableList;
